import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const serverUrl = () => process.env.REACT_APP_SERVER_URL_API || 'http://localhost:8090';

// Same rationale as ordersApi.js: a dedicated instance that reads the cookie
// per request, instead of relying on TokenContext's global interceptor.
const client = axios.create();
client.interceptors.request.use((config) => {
    const token = cookies.get('DASHBOARD_ACCESS');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// { has_quotes, quotes } — has_quotes covers pending devis too (so the "Mes
// devis" tab can appear the moment an admin issues the first one), quotes
// itself only lists decided ones (accepted/declined).
export async function getQuotes() {
    const { data } = await client.get(`${serverUrl()}/api/quotes`);
    return data;
}

// Reissues the accept/decline link for the caller's own pending devis and
// returns { ephemeral_url } — the old link stops working once this is called.
export async function regenerateQuoteLink(id) {
    const { data } = await client.post(`${serverUrl()}/api/quotes/${id}/regenerate-link`);
    return data;
}
